import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import authEN from "./locales/en/auth.json";

const resources = {
  en: {
    auth: authEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en",
  fallbackLng: "en",
  defaultNS: "auth",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
